module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "index"
  }, [_c('div', {
    staticClass: "nav centered"
  }, _vm._l((_vm.userMenu), function(item) {
    return _c('router-link', {
      key: item.name,
      staticClass: "nav-item is-tab",
      attrs: {
        "to": {
          name: item.name
        },
        "active-class": "is-active"
      }
    }, [_vm._v(_vm._s(item.title))])
  }), 1), _vm._v(" "), _c('router-view')], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0a1c7ec9"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Documents/Index.vue
// module id = 890
// module chunks = 0